import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CILDashboardService } from 'src/app/services/cil-dashboard-service';
import { DtServiceService } from 'src/app/services/dtService.service';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { ShopFloorDataService } from 'src/app/services/shopFloorData.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { Chart } from 'angular-highcharts';
import { MatDialog } from '@angular/material/dialog';
import { resourceUsage } from 'process';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AuditDashboard } from 'src/app/services/audit-dashboard.service';
import * as moment from 'moment';
import { differenceInCalendarDays } from 'date-fns';
import { OleService } from 'src/app/services/ole.service';
import { CustomLoadingOverlay } from 'src/app/custom-loading-overlay.component';
import { BtnCellRendererGembaDashBoard } from 'src/app/btn-cell-rendererGembaDashBoard.component';
import { MatCheckboxRendererComponent } from 'src/app/mat-checkbox-renderer';
import { BtnCellRenderer } from 'src/app/btn-cell-renderer.component';
import { GembaWalkService } from 'src/app/services/gemba-walk.service';
import { ButtonViewRendererComponent } from 'src/app/components/button-view-render.components';
import * as XLSX from 'xlsx-js-style';
import * as _ from 'lodash';
import { Multilingual } from 'src/app/services/multilingual';
import { BaseApi } from 'src/backend/api/base-api';
import { timeStamp } from 'console';
import { LoggedUser } from 'src/backend/models/session-users/session-users';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-five-s-dashboard',
  templateUrl: './five-s-dashboard.component.html',
  styleUrls: ['./five-s-dashboard.component.scss'],
})
export class FiveSDashboardComponent implements OnInit {
  @ViewChild('5SPoup') private groupLicensePopup!: TemplateRef<any>;
  @ViewChild('imageZoomModel') private imageZoomModel!: TemplateRef<any>;
  @ViewChild('CloseObservation') private CloseObservation!: TemplateRef<any>;
  @ViewChild('ViewActionDetailModel') private ViewActionDetailModel!: TemplateRef<any>;
  @ViewChild('imageViewModal') private imageViewModal!: TemplateRef<any>;
  todayDate = new Date();
  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.todayDate) > 0;
  breadcrumList: any;
  isHide: boolean = true;
  moduleId: any;
  pageId: any;
  permisson: any;
  IsAccess: any;
  IsWrite: any;
  FiveSDashboardForm: any;
  spinnerText: string;
  groupList: any;
  groupFiltList: any;
  plantList: any;
  plantFiltList: any;
  charts: any = [];
  values: any = [];
  data: any;
  options = {};
  ORPGraphData: any = [];
  percentage: any;
  stock: any;
  fiveSList = [];
  drillDownData: any = [];
  barGraphDataresponse: any = [];
  barGraphData: any = [];
  fivesPoupValue: any = [];
  fivesPoupLabel: any = [];
  ORPGraphValues: any = [];
  chart: Chart;
  isPopupOpen: boolean = false;
  lang: any;
  languageDir = 'ltr';
  langObj: any = {};
  columnDefs!: any;
  dataArray: any;
  public detailCellRendererParams!: any;
  gridOptions: any = {
    defaultColDef: { flex: 1 },
  };
  gridApi: any;
  gridColumnApi: any;
  startDate: any;
  endDate: any;
  Current: any;
  Previous: any;
  SearchType: number = 1;
  SearchType2: number = 1;
  fiveSCatagoryCatagories: any[] = [];
  disabledExport = true;
  loadingOverlayComponent: any;
  parentListExport: any[] = [];
  gembaRowData!: any[];
  gembaColDef: any;
  gembaGridOptions: any = {
    defaultColDef: {
      rowModelType: 'infinite',
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: false,     // <-- HERE
      autoHeight: true,   // <-- & HERE
      minWidth: 225,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },

    frameworkComponents: {
      buttonRenderer: ButtonViewRendererComponent,
      btnCellRendererGembaDashBoard: BtnCellRendererGembaDashBoard,
      customLoadingOverlay: CustomLoadingOverlay,
    }
  };
  ButtonTypeGemba: string;
  gembaGridApi: any;
  gembaGridColumnApi: any;
  closeGembaForm!: FormGroup;
  CloseImage = '';
  currentImagePath: any;
  columnDefsActionView: any;
  gembaWalkId: any;
  rowDataViewActions!: any;
  actionGridOption: any = {
    defaultColDef: {
      filter: 'agTextColumnFilter',
      headerHeight: 50,
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    paginationPageSize: 10,
    popupParent: document.querySelector('body'),
    frameworkComponents: {
      btnCellRenderer: BtnCellRenderer,
      checkboxRenderer: MatCheckboxRendererComponent,
    },
  };
  slidesImages: any[] = [];
  plantSession: any;
  userSession: LoggedUser;

  isAccess = ApplicationPermission.New_FiveSGemba_ACCESS;
  isCreate = ApplicationPermission.New_FiveSGemba_CREATE;
  isUpdate = ApplicationPermission.New_FiveSGemba_UPDATE;
  isDelete = ApplicationPermission.New_FiveSGemba_DELETE;
  constructor(
    private baseApi: BaseApi,
    private toaster: ToastrService,
    public router: Router,
    private userService: UserManagementService,
    private enterpriseGroupService: EnterPriseGroupService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private dtService: DtServiceService,
    private sfdService: ShopFloorDataService,
    private CILDashboardService: CILDashboardService,
    private ChangeDetectorRef: ChangeDetectorRef,
    private auditDashboardService: AuditDashboard,
    private dialog: MatDialog,
    public translater: TranslaterService,
    public translate: TranslateService,
    private oleService: OleService,
    private gembaService: GembaWalkService,
  ) {
    this.loadingOverlayComponent = 'customLoadingOverlay';
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
    this.columnDefsActionView = [
      {
        headerName: this.langObj ? this.langObj?.ActionName : 'ActionName',
        field: 'ActionName',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: this.langObj ? this.langObj?.Responsible : 'Responsible',
        field: 'responsibleName',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: this.langObj ? this.langObj?.NoOfMisses : 'No Of Misses',
        field: 'NoOfMisses',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'Observation',
        headerName: this.langObj ? this.langObj?.Observation : 'Observation',
        sortable: true,
        filter: true,
        resizeable: true,
        wrapText: true
      },
      {
        field: 'Remarks',
        headerName: this.langObj ? this.langObj?.Remarks : 'Remarks',
        sortable: true,
        filter: true,
        resizeable: true,
        wrapText: true
      },
      {
        headerName: this.langObj ? this.langObj?.TargetDate : 'TargetDate',
        field: 'TargetDate',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        valueFormatter: function (params: any) { return params.value !== null ? moment(params.value).format('DD/MM/YYYY HH:mm:ss') : '' }
      },
      {
        headerName: this.langObj ? this.langObj?.NewTargetDate : 'NewTargetDate',
        field: 'NewTargetDate',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        valueFormatter: function (params: any) { return params.value !== null ? moment(params.value).format('DD/MM/YYYY HH:mm:ss') : '' }
      },
      {
        headerName: this.langObj ? this.langObj?.PictureAfterRequire : 'PictureAfter Req',
        field: 'IsRequiredPictureAfter',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        cellRenderer: 'checkboxRenderer',
        cellRendererParams: { disable: true },
        editable: false,
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'PictureAfter',
        headerName: this.langObj ? this.langObj?.PictureAfter : 'Picture After',
        sortable: true,
        resizable: true,
        filter: false,
        cellRenderer: function (params: any) {
          let html = `<img style="width: 50px; height: 40px;" src="assets/images/no-image.png"/>`;
          if (params && params.value) {
            html = '';
            html = `<img style="width: 50px; height: 40px;" src="${params.value}"/>`;

          }
          return html;
        },
      },
      {
        headerName: this.langObj ? this.langObj?.Rejected : 'Rejected',
        field: 'IsRejected',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        cellRenderer: 'checkboxRenderer',
        cellRendererParams: { disable: true },
        editable: false,
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'IsCompleted',
        headerName: this.langObj ? this.langObj?.Completed : 'Completed',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        cellRenderer: 'checkboxRenderer',
        cellRendererParams: { disable: true },
        editable: false,
        // headerValueGetter: this.localizeHeader.bind(this)
      },

      {
        field: 'IsVerified',
        headerName: this.langObj ? this.langObj?.Verified : 'Verified',
        sortable: true,
        filter: true,
        resizable: true,
        width: 200,
        wrapText: true,
        hide: !this.IsWrite,
        cellRenderer: 'checkboxRenderer',
        cellRendererParams: { disable: true },
        editable: false,
      },
    ];
    this.columnDefs = [
      // { field: 'EG_Desc', headerName: 'Group' },
      // { field: 'PT_Desc', headerName: 'Plant' },
      {
        field: 'AreaName', headerName: 'Area Name', cellRenderer: 'agGroupCellRenderer', resizable: true,
        headerValueGetter: this.localizeHeader.bind(this),
        filter: true
      },
      // { field: 'AuditCategory', headerName: 'Audit Category' ,  resizable: true,
      // filter: true},
      {
        field: 'Findings', headerName: 'Finding(Non-Complience)', resizable: true,
        headerValueGetter: this.localizeHeader.bind(this),
        filter: true
      },
    ];
    this.gembaColDef = [
      {
        field: 'Actions',
        cellRenderer: 'btnCellRendererGembaDashBoard',
        cellRendererParams: {
          clicked: function (field: any) { },
        },
        headerValueGetter: this.localizeHeader.bind(this),
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
      },
      {
        field: 'Observation', headerName: 'Observation', resizable: true,
        headerValueGetter: this.localizeHeader.bind(this),
        filter: true
      },
      {
        field: 'Category', headerName: 'Category', resizable: true,
        headerValueGetter: this.localizeHeader.bind(this),
        filter: true
      },
      {
        field: 'AreaName', headerName: 'Area Name', resizable: true,
        headerValueGetter: this.localizeHeader.bind(this),
        filter: true
      },
      {
        field: 'Status', headerName: 'Status', resizable: true,
        headerValueGetter: this.localizeHeader.bind(this),
        filter: true
      },
      {
        headerName: 'Pre Image', field: 'PreImage', cellRenderer: function (params: any) { return `<img style="width:40px;height:40px ;cursor:pointer" alt="${params.value}" src="${params.value !== '' ? params.value : 'assets/images/no-image.png'}">` },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        field: 'CreatedBy', headerName: 'Created By', resizable: true,
        headerValueGetter: this.localizeHeader.bind(this),
        filter: true
      },
      {
        field: 'CreatedOn', headerName: 'Created On', resizable: true, valueFormatter: function (params: any) { return moment(params.value).format('DD/MM/YYYY HH:mm:ss') },
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'ClosedDate', headerName: 'Closed Date', resizable: true, valueFormatter: function (params: any) {
          if (params.value) {
            return moment(params.value).format('DD/MM/YYYY HH:mm:ss')
          }
        },
        headerValueGetter: this.localizeHeader.bind(this),
        filter: true
      },
      {
        field: 'ClosedBy', headerName: 'Closed By', resizable: true,
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },

    ]
    this.detailCellRendererParams = {
      detailGridOptions: {
        columnDefs: [
          {
            field: 'AuditCategory', headerName: 'Audit Category', cellRenderer: 'agGroupCellRenderer',
            headerValueGetter: this.localizeHeader.bind(this), filter: true
          },
          {
            field: 'finding', headerName: 'Finding(Non-Complience)',
            headerValueGetter: this.localizeHeader.bind(this), filter: true
          }
        ],
        frameworkComponents: {
          customLoadingOverlay: CustomLoadingOverlay,
        },
        defaultColDef: { flex: 1 },
        suppressRowTransform: true,
        masterDetail: true,
        detailRowAutoHeight: true,
        detailCellRendererParams: {
          suppressRowTransform: true,
          masterDetail: true,
          detailGridOptions: {
            columnDefs: [
              {
                field: 'checkpoint', headerName: 'CheckPoint',
                headerValueGetter: this.localizeHeader.bind(this), filter: true
              },
              {
                field: 'score', headerName: 'Score',
                headerValueGetter: this.localizeHeader.bind(this), filter: true
              }
            ],
            defaultColDef: { flex: 1 },
            pagination: true,
            paginationPageSize: 3,
          },
          getDetailRowData: function (params: any) {
            params.successCallback(params.data.Detail);
          },
        }
      },
      getDetailRowData: function (params: any) {
        params.successCallback(params.data.Detail);
      },
    };
  }
  ngAfterViewInit() {
    this.generateDynamicclass();
  }
  ngOnInit() {
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.userSession = this.baseApi.getUserSession();
    this.FiveSDashboardForm = this.fb.group({
      // plant: ['', Validators.required],
      // group: ['', Validators.required],
      startDate: [
        new Date(moment().subtract(1, 'd').toString()),
        Validators.required,
      ],
      endDate: [new Date(), Validators.required],
      datepicker: [],
    });
    this.closeGembaForm = this.fb.group({
      remarks: [''],
      image: [''],
    })
    const dates = [];
    dates.push(new Date(moment().subtract(1, 'd').toString()));
    dates.push(new Date());
    this.FiveSDashboardForm.get('datepicker')?.setValue(dates, {
      emitEvent: false,
    });
    this.getLangWords();
    this.getFiveSDashboardDataPrev(1);
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    this.moduleId = this.baseApi.getUserPermissionsSession().find(x => x.menuId == this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
        this.gembaGridApi.refreshHeader();
      }
    });
  }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridColumnApi.autoSizeAllColumns();
    this.gridApi.setDomLayout('autoHeight');
    const e: HTMLElement = document.querySelector('#eGrid') as HTMLElement;
    if (e !== null) {
      e.style.height = '';
    }
  }

  autoSizeAll() {
    this.gridApi.setRowData(this.dataArray);
    this.gridColumnApi.autoSizeAllColumns();
  }


  gembaOnGridReady(params: any): any {
    this.gembaGridApi = params.api;
    this.gembaGridColumnApi = params.columnApi;
    this.gembaGridColumnApi.autoSizeAllColumns();
  }

  autoSizeGemba() {
    this.gembaGridApi.setRowData(this.gembaRowData);
    this.gembaGridColumnApi.autoSizeAllColumns();
  }

  onBtnExportCSV(): void {
    this.gridOptions.api.exportDataAsCsv();
  }

  onBtnExportExcel(): void {
    // this.gridOptions.api.exportDataAsExcel();
    const Array: any = []
    for (let master of this.parentListExport) {
      if (master.Detail) {
        for (let child of master.Detail) {
          const key = {
            AreaName: master.AreaName,
            AuditCategory: master.AuditCategory,
            Checkpoint: child.checkpoint,
            Score: child.score
          }
          Array.push(key);
        }
      }
      else {
        const key = {
          AreaName: master.AreaName,
          AuditCategory: master.AuditCategory,
        }
        Array.push(key);
      }
    }
    this.oleService.exportAsExcelFile(Array, '5S Execution');
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }


  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  generateDynamicclass() {
    this.values = [];
    this.values = this.data;

    setTimeout(() => {
      this.createOverallGauge();
    }, 100);
  }
  createOverallGauge() {
    const percentageArr: any = [];
    let sum;
    if (this.values && this.values.length) {
      this.values.map((val: any, index: number) => {
        percentageArr.push(val.TotalPercentage);
      });
      sum = percentageArr.reduce((accumulator, curr) => {
        return accumulator + curr;
      });
      if (sum != 0) {
        this.percentage = Math.floor(sum / percentageArr.length + 1);
      }

      const chart = Highcharts.chart(`overall-chart-gauge`, {
        chart: {
          type: 'solidgauge',
          margin: [0, 0, 0, 0],
        },
        title: {
          text: this.getTransalatedValue('5S Overall Score'),
          floating: true,
          y: 340,
          style: {
            color: '#000',
            fontSize: '20px',
            fontWeight: '700',
            margin: 30,
          },
        },
        credits: {
          enabled: false,
        },
        pane: {
          startAngle: -90,
          endAngle: 90,
          center: ['50%', '80%'],
          background: {
            innerRadius: '60%',
            outerRadius: '100%',
            shape: 'arc',
          },
        },
        exporting: { enabled: false },
        yAxis: {
          min: 0,
          max: 100,
          stops: [
            [0.2, '#DF5353'], // Red from 0 to 20
            [0.2, '#FFA500'], // Orange starts immediately at 20
            [0.5, '#FFA500'], // Orange up to 50
            [0.5, '#DDDF0D'], // Yellow starts immediately at 50
            [0.8, '#DDDF0D'], // Yellow up to 80
            [0.8, '#55BF3B'], // Green starts immediately at 80

            // [0.1, '#DF5353'], // red
            // [0.5, '#DDDF0D'], // yellow
            // [0.9, '#55BF3B'], // green
          ],
          minorTickInterval: null,
          tickAmount: 2,
          labels: {
            y: 16,
          },
        },
        plotOptions: {
          solidgauge: {
            dataLabels: {
              y: -25,
              borderWidth: 0,
              useHTML: true,
            },
          },
        },
        tooltip: {
          enabled: false,
        },
        series: [
          {
            name: null,
            data: [0],
            dataLabels: {
              format:
                '<div style="text-align: center"><span style="font-size: 1.25rem">{y}</span></div>',
            },
          },
        ],
      } as any);
      setTimeout(() => {
        chart.series[0].points[0].update(this.percentage);
      }, 0);
      this.createChartGauge();
      this.ChangeDetectorRef.detectChanges();
    }
  }
  createChartGauge() {
    if (this.values && this.values.length) {
      let a = document.querySelectorAll('div .gauge-divider');
      if (this.values.length >= 10) {
        let a = document.querySelectorAll('div .gauge-divider');
        a.forEach((node: any) => (node.style.width = '20%'));
      } else {
        a.forEach((node: any) => (node.style.width = '25%'));
      }

      this.values.map((val: any, index: any) => {
        const chart = Highcharts.chart(`chart-gauge-${index}`, {
          chart: {
            type: 'solidgauge',
            margin: [0, 0, 0, 0],
          },
          title: {
            useHTML: true,
            text: this.getTransalatedValue(val.AreaName),
            y: 150,

            style: {
              color: '#fff',
              fontSize: '13px',
              margin: '1px',
              padding: '8px',
              'background-color': '#325aa8',
              'border-radius': '5px',
              widthAdjust: 500,
            },
          },
          credits: {
            enabled: false,
          },
          pane: {
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '50%'],
            // size: '160%',
            background: {
              innerRadius: '60%',
              outerRadius: '100%',
              shape: 'arc',
            },
          },
          exporting: { enabled: false },
          yAxis: {
            min: 0,
            max: 100,
            stops: [
              [0.2, '#DF5353'], // Red from 0 to 20
              [0.2, '#FFA500'], // Orange starts immediately at 20
              [0.5, '#FFA500'], // Orange up to 50
              [0.5, '#DDDF0D'], // Yellow starts immediately at 50
              [0.8, '#DDDF0D'], // Yellow up to 80
              [0.8, '#55BF3B'], // Green starts immediately at 80
              // [0.1, '#DF5353'], // red
              // [0.5, '#DDDF0D'], // yellow
              // [0.9, '#55BF3B'], // green
            ],
            minorTickInterval: null,
            tickAmount: 2,
            labels: {
              y: 16,
            },
          },
          plotOptions: {
            solidgauge: {
              dataLabels: {
                y: -25,
                borderWidth: 0,
                useHTML: true,
              },
            },
          },
          tooltip: {
            enabled: false,
          },
          series: [
            {
              name: null,
              data: [0],
              cursor: 'pointer',
              events: {
                click: (event) => {
                  this.onClick(
                    event.point.options.y,
                    event.point.series.chart.options.title.text
                  );
                },
              },
              dataLabels: {
                format:
                  '<div style="text-align: center"><span style="font-size: 1.25rem">{y}</span></div>',
              },
            },
          ],
        } as any);
        setTimeout(() => {
          if (chart?.series?.length) {
            chart?.series[0]?.points[0]?.update(
              Math.round(val.TotalPercentage * 10) / 10
            );
          }
        }, 1500);
      });
      this.createORPBarGraph();
    }
    this.ChangeDetectorRef.detectChanges();
  }

  createORPBarGraph() {
    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.getTransalatedValue('Total Gemba Findings'),
        style: {
          color: '#000',
          fontSize: '20px',
          fontWeight: '700',
          marginTop: '20px',
        },
      },
      accessibility: {
        announceNewData: {
          enabled: true,
        },
      },
      xAxis: {
        type: 'category',
      },
      yAxis: {
        title: {
          text: '',
        },
      },
      // legend: {
      //   enabled: false,
      // },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '15px',
              fontWeight: '700',
              marginTop: '20px',
            },
          },
        },
        column: {
          pointWidth: 50,
        },
      },
      colors: ['#7cb5ec'],
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b> of total<br/>',
      },

      series: [
        {
          name: 'Gemba Walk',
          colorByPoint: true,
          data: this.ORPGraphValues,
          cursor: 'pointer',
        },
      ],

      drilldown: {
        breadcrumbs: {
          buttonTheme: {
            fill: '#f7f7f7',
            padding: 8,
            stroke: '#cccccc',
            'stroke-width': 1,
          },
          floating: true,
          position: {
            align: 'right',
          },
          showFullPath: true,
        },
        series: this.drillDownData,
      },
    };

    let chart = new Chart(this.options);
    this.ORPGraphData = chart;
  }



  onSubmit(): void {
    this.SearchType2 = 2
    const data = {
      areaId: this.FiveSDashboardForm.value.group,
      // ptId: this.FiveSDashboardForm.value.plant,
      PTCode: this.plantSession?.plantCode,
      dateStart: moment(this.FiveSDashboardForm.value.datepicker[0]).utc(),
      dateEnd: moment(this.FiveSDashboardForm.value.datepicker[1]).utc(),
    };
    this.spinner.show();
    this.drillDownData = [];
    this.ORPGraphValues = [];
    this.CILDashboardService.getFiveSDashboardData(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.percentage = '';
        this.values = [];
        this.data = res;
        this.generateDynamicclass();
        this.GetNewGembaWalkDash();
        this.GetAllExportData(3);
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error(err, 'Error');
        this.GetNewGembaWalkDash();
        this.GetAllExportData(3);
      }
    );
    this.getGembaReport();
  }
  onClick(val: any, name: any) {
    if (val == 0) {
      return;
    } else {
      if (this.isPopupOpen == false) {
        this.isPopupOpen = true;
        this.data.map((res: any) => {
          if (
            Math.round(res.TotalPercentage * 10) / 10 == val &&
            name == res.AreaName
          ) {
            this.getNoOf5sFindingOverall(res.AreaId);
          }
        });
      }
    }
  }
  getDashboardData() {
    const data = {
      areaId: this.FiveSDashboardForm.value.group,
      // ptId: this.FiveSDashboardForm.value.plant,
      PTCode: this.plantSession?.plantCode,
      dateStart: moment(this.FiveSDashboardForm.value.datepicker[0]).utc(),
      dateEnd: moment(this.FiveSDashboardForm.value.datepicker[1]).utc(),
    };
    this.spinner.show();
    this.data = [];
    this.CILDashboardService.getFiveSDashboardData(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.data = res;
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error(err, 'Error');
      }
    );
  }

  getNoOf5sFindingOverall(val) {
    if (this.SearchType2 === 2) {
      const data = {
        areaId: val,
        ptCode: this.plantSession?.plantCode,
        fromDate: moment(this.FiveSDashboardForm.value.datepicker[0]).utc(),
        toDate: moment(this.FiveSDashboardForm.value.datepicker[1]).utc(),
      };

      this.spinner.show();
      this.fivesPoupValue = [];
      this.CILDashboardService.getNoOf5sFindingOverall(data).subscribe(
        (res: any) => {
          this.spinner.hide();
          const data = res;
          // data.map((res) => {
          //   this.fivesPoupValue.push({ name: res.Name, y: res.Finding });
          // });

          if (res) {
            this.fiveSCatagoryCatagories = [...new Set(res.map(x => x.Name))]
            const key = {
              name: 'Non Complience',
              data: [],
              color: '#cc1212'
            }
            const key2 = {
              name: 'Complience',
              data: [],
              color: '#3acc12'
            }
            for (let obj of this.fiveSCatagoryCatagories) {
              const objResponse = res.find(c => c.Name === obj)
              key.data.push(objResponse.NonComplience)
            }
            for (let obj of this.fiveSCatagoryCatagories) {
              const objResponse = res.find(c => c.Name === obj)
              key2.data.push(objResponse.Complience)
            }
            this.fivesPoupValue.push(key);
            this.fivesPoupValue.push(key2);
            this.openPopup();
            this.ChangeDetectorRef.detectChanges();
          }


        },
        (err: any) => {
          this.spinner.hide();
          this.toaster.error(err, 'Error');
        }
      );
    }
    else {
      const data = {
        areaId: val,
        // ptId: this.FiveSDashboardForm.value.plant ,
        ptCode: this.plantSession?.plantCode,
        search: this.SearchType
      };

      this.spinner.show();
      this.fivesPoupValue = [];
      this.CILDashboardService.getNoOf5sFindingOverallPrev(data).subscribe(
        (res: any) => {
          this.spinner.hide();
          // const data = res;
          // data.map((res) => {
          //   this.fivesPoupValue.push({ name: res.Name, y: res.Finding });
          // });
          if (res) {
            this.fiveSCatagoryCatagories = [...new Set(res.map(x => x.Name))]
            const key = {
              name: 'Non Complience',
              data: [],
              color: '#cc1212'
            }
            const key2 = {
              name: 'Complience',
              data: [],
              color: '#3acc12'
            }
            for (let obj of this.fiveSCatagoryCatagories) {
              const objResponse = res.find(c => c.Name === obj)
              key.data.push(objResponse.NonComplience)
            }
            for (let obj of this.fiveSCatagoryCatagories) {
              const objResponse = res.find(c => c.Name === obj)
              key2.data.push(objResponse.Complience)
            }
            this.fivesPoupValue.push(key);
            this.fivesPoupValue.push(key2);
            this.openPopup();
            this.ChangeDetectorRef.detectChanges();
          }
        },
        (err: any) => {
          this.spinner.hide();
          this.toaster.error(err, 'Error');
        }
      );
    }

  }

  openPopup() {
    let dialogRef = this.dialog.open(this.groupLicensePopup, {
      minWidth: '80%',
      minHeight: '50%',
    });

    dialogRef.afterOpened().subscribe((res: any) => {
      this.createFiveSChart();
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.isPopupOpen = false;
    });
  }

  createFiveSChart() {
    this.options = {
      chart: {
        type: 'column',
      },

      title: {
        text: this.getTransalatedValue('NonCompliancein5SCategories'),
      },

      xAxis: {
        categories: this.fiveSCatagoryCatagories,
        crosshair: true
      },
      // legend: {
      //   enabled: false,
      // },
      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: null,
        },
      },
      plotOptions: {
        column: {
          pointWidth: 50,
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
          },
        },
      },

      series: this.fivesPoupValue
    };

    let chart = new Chart(this.options);
    this.chart = chart;
  }
  GetNewGembaWalkDash() {
    const data = {
      // userId: JSON.parse(localStorage.getItem('user')).UserId,
      userCode: this.userSession?.userCode,
      PTCode: this.plantSession?.plantCode,
      // PTID: this.FiveSDashboardForm.value.plant,
      dateStart: moment(this.FiveSDashboardForm.value.datepicker[0]).utc(),
      dateEnd: moment(this.FiveSDashboardForm.value.datepicker[1]).utc(),
    };
    this.barGraphDataresponse = [];
    // this.drillDownData = [];
    this.CILDashboardService.GetNewGembaWalkDash(data).subscribe(
      (res: any) => {
        const data = [];

        this.barGraphDataresponse = res;
        this.barGraphDataresponse.map((res: any) => {
          data.push({ Status: res.ObservationStatus, category: res.Category });
        });
        let key = {
          Closed: 0,
          Open: 0
        }
        for (const val of data) {
          if (val.Status === 'Closed') {
            key.Closed += 1;
          }
          else {
            key.Open += 1;
          }
        }
        console.log('key', key)
        // let a = {};
        // for (const val of data) {
        //   if (a[val.areaName]) {
        //     a[val.areaName] += 1;
        //   } else {
        //     a[val.areaName] = 1;
        //   }
        // }
        for (const key2 in key) {
          this.ORPGraphValues.push({ name: key2, y: key[key2], drilldown: key2 });
        }
        const drillDownRecord = [];

        if (key.Closed > 0) {
          const closed = {
            id: 'Closed',
            name: 'Closed',
            data: [
            ]
          }
          drillDownRecord.push(closed)
        }

        if (key.Open > 0) {
          const Open = {
            id: 'Open',
            name: 'Open',
            data: []
          }
          drillDownRecord.push(Open)
        }

        for (const val of this.barGraphDataresponse) {
          const valIndex = drillDownRecord.findIndex(
            (rec: any) => rec.name == (val.ObservationStatus === 'Closed' ? 'Closed' : 'Open')
          );
          const cat = drillDownRecord[valIndex]['data'].findIndex(
            (ObservationStatus: any) => ObservationStatus.name == val.AreaName
          );
          if (
            drillDownRecord[valIndex]['data'] &&
            drillDownRecord[valIndex]['data'][cat]
          ) {
            drillDownRecord[valIndex]['data'][cat]['y'] += 1;
          }
          else {
            drillDownRecord[valIndex]['data'].push({
              name: val.AreaName,
              y: 1,
              drilldown: val.AreaName + '-' + (val.ObservationStatus === 'Closed' ? 'Closed' : 'Open')
            });
          }

        }

        for (const val of this.barGraphDataresponse) {
          const valIndex = drillDownRecord.findIndex(
            (rec: any) => rec.id == val.AreaName + '-' + (val.ObservationStatus === 'Closed' ? 'Closed' : 'Open')
          );
          if (drillDownRecord && drillDownRecord[valIndex]) {
            const cat = drillDownRecord[valIndex]['data'].findIndex(
              (ObservationStatus: any) => ObservationStatus.name == val.Category
            );
            if (
              drillDownRecord[valIndex]['data'] &&
              drillDownRecord[valIndex]['data'][cat]
            ) {
              drillDownRecord[valIndex]['data'][cat]['y'] += 1;
            }
            else {
              drillDownRecord[valIndex]['data'].push({
                name: val.Category,
                y: 1
              });
            }
          }
          else {
            const key = {
              id: val.AreaName + '-' + (val.ObservationStatus === 'Closed' ? 'Closed' : 'Open'),
              name: val.AreaName,
              data: [
                {
                  name: val.Category,
                  y: 1
                }
              ]
            }
            drillDownRecord.push(key)
          }
        }
        console.log(drillDownRecord, 'datadrilldown')
        this.drillDownData = drillDownRecord;

        this.generateDynamicclass();
      },
      (err: any) => {
        this.toaster.error(err, 'Error');
      }
    );
  }

  onChange(a) {
    this.startDate = a.toString();
    // this.endDate = this.date.split(',');
  }
  GetAllExportData(numb: number): void {
    const key = {
      // egId: this.FiveSDashboardForm.value.group,
      // ptId: this.FiveSDashboardForm.value.plant,
      ptCode: this.plantSession?.plantCode,
      fromDate: moment(this.FiveSDashboardForm.value.datepicker[0]).utc(),
      toDate: moment(this.FiveSDashboardForm.value.datepicker[1]).utc(),
      execId: numb
      // fromDate:  moment(this.FiveSDashboardForm.value.datepicker[0]).utc(),
      // toDate: moment(this.FiveSDashboardForm.value.datepicker[1]).utc(),

    }
    this.dataArray = []
    this.parentListExport = []
    this.gridApi.showLoadingOverlay();

    this.auditDashboardService.GetAllExportData(key).subscribe((res: any) => {
      const parentList = [];
      for (let i = 0; i < res?.length; i++) {
        if (parentList?.length > 0) {
          let flag = true;
          for (let j = 0; j < parentList?.length; j++) {
            if (res[i].AreaId === parentList[j].AreaId &&
              res[i].MasterAuditCategoryId === parentList[j].MasterAuditCategoryId) {
              const childkey = {
                score: res[i].Score ? res[i].Score : res[i].CatType,
                checkpoint: res[i].checkpoint
              }
              parentList[j].Detail.push(childkey)
              flag = false;
              break
            }
          }
          if (flag) {
            const childkey = {
              score: res[i].Score ? res[i].Score : res[i].CatType,
              checkpoint: res[i].checkpoint
            }
            const key = {
              AreaId: res[i].AreaId,
              AreaName: res[i].AreaName,
              AuditCategory: res[i].AuditCategory,
              MasterAuditCategoryId: res[i].MasterAuditCategoryId,
              finding: 0,
              Detail: [childkey]
            }
            parentList.push(key);
          }
        }
        else {
          const childkey = {
            score: res[i].Score ? res[i].Score : res[i].CatType,
            checkpoint: res[i].checkpoint
          }
          const key = {
            AreaId: res[i].AreaId,
            AreaName: res[i].AreaName,
            AuditCategory: res[i].AuditCategory,
            MasterAuditCategoryId: res[i].MasterAuditCategoryId,
            finding: 0,
            Detail: [childkey]
          }
          parentList.push(key);
        }
      }
      if (parentList?.length > 0) {
        this.parentListExport = parentList;
        for (let i = 0; i < parentList?.length; i++) {
          parentList[i].finding = parentList[i]?.Detail?.length;
        }
      }
      const grandParentList = []
      if (parentList?.length > 0) {
        for (let i = 0; i < parentList?.length; i++) {
          if (grandParentList?.length > 0) {
            let flag = true;
            for (let j = 0; j < grandParentList?.length; j++) {
              if (grandParentList[j].AreaId === parentList[i].AreaId) {
                grandParentList[j].Detail.push(parentList[i])
                flag = false
                break;
              }
            }
            if (flag) {
              const key = {
                AreaId: parentList[i].AreaId,
                AreaName: parentList[i].AreaName,
                finding: 0,
                Detail: []
              }
              key.Detail.push(parentList[i]);
              grandParentList.push(key);
            }
          }
          else {
            const key = {
              AreaId: parentList[i].AreaId,
              AreaName: parentList[i].AreaName,
              finding: 0,
              Detail: []
            }
            key.Detail.push(parentList[i]);
            grandParentList.push(key);
          }
        }
      }
      if (grandParentList?.length > 0) {
        for (let i = 0; i < grandParentList?.length; i++) {
          let counter = 0;
          for (let j = 0; j < grandParentList[i]?.Detail?.length; j++) {
            counter = counter + grandParentList[i]?.Detail[j]?.Detail?.length

          }
          grandParentList[i].finding = counter;
        }
      }
      this.dataArray = grandParentList
      this.autoSizeAll();
      // this.gridApi.setRowData(this.dataArray)
      this.gridOptions.api.hideOverlay();


    });

  }
  getFiveSDashboardDataPrev(numb: number): void {
    this.SearchType = numb
    this.SearchType2 = 1

    let startDate: moment.Moment;
    let endDate: moment.Moment;

    if (numb === 1) {
    // Current day
    startDate = moment().startOf('day');
    endDate = moment().endOf('day');
    } else if (numb === 2) {
    // Previous day
    startDate = moment().subtract(1, 'day').startOf('day');
    endDate = moment().subtract(1, 'day').endOf('day');
   }

  // Set datepicker value in form
  this.FiveSDashboardForm.get('datepicker')?.setValue([startDate.toDate(), endDate.toDate()]);
    const key = {
      PTCode: this.plantSession?.plantCode,
      Execid: numb
    }
    this.spinner.show()
    this.CILDashboardService.getFiveSDashboardDataPrev(key).subscribe((res: any) => {
      this.spinner.hide();
      this.percentage = '';
      this.values = [];
      this.data = res;
      this.generateDynamicclass();
      this.GetNewGembaWalkDash();
      this.GetAllExportData(numb);
    }, (error) => {
      this.spinner.hide()
      this.toaster.error('Error', error.Message)
      this.GetNewGembaWalkDash();
      this.GetAllExportData(numb);
    });
    this.getGembaReport();
  }

  getGembaReport(): void {
    const data = {
      // userId: JSON.parse(localStorage.getItem('user')).UserId,
      // PTID: this.FiveSDashboardForm.value.plant,
      PTCode: this.plantSession?.plantCode,
      userCode: this.userSession?.userCode,
      dateStart: moment(this.FiveSDashboardForm.value.datepicker[0]).utc(),
      dateEnd: moment(this.FiveSDashboardForm.value.datepicker[1]).utc(),
    };
    //  this.gembaGridApi = [];

    this.gembaGridApi?.showLoadingOverlay();

    this.CILDashboardService.getGembaReport(data).subscribe(
      (res: any) => {
        this.gembaRowData = res;
        this.autoSizeGemba();
        this.gembaGridOptions.api.hideOverlay();
      });
  }

  cellClickedGemba(params: any): void {
    this.ButtonTypeGemba = '';
    const col = params.colDef.field;
    this.ButtonTypeGemba = params.event.target.classList[2];
    if (col === 'PreImage') {
      this.spinner.show();
      this.gembaWalkId = params.data.GembaWalkId;
      this.getGembafiles()
    }
    if (col === 'Actions') {
      this.ButtonTypeGemba = params.event.target.textContent;
      if (this.ButtonTypeGemba === 'remove_red_eye 2 ') {
        this.closeGembaForm.get('remarks').setValue('')

        this.dialog.open(this.CloseObservation, {
          width: '30%',
          height: 'auto',
        });
        this.CloseImage = params.data.CloseImage;
        this.closeGembaForm.get('remarks').setValue(params.data.ClosedRemarks)
      }
      else if (this.ButtonTypeGemba === 'remove_red_eye') {
        // this.closedefect(params.data);
        this.gembaWalkId = params.data.GembaWalkId;
        if (params.data.NoOfActions == 0 || params.data.NoOfActions == null) {
          this.toaster.warning("Actions Not Available")
        }
        else {
          this.openViewActions(params.data);
        }

      }
    }
  }

  imageZoom(): void {
    this.currentImagePath = this.CloseImage ? this.CloseImage : 'assets/images/no-image.png'
    this.dialog.open(this.imageZoomModel, { height: '90%', width: '90%' });
  }

  openViewActions(gemba: any): void {
    this.getGembaActions(gemba.id);
    this.dialog.open(this.ViewActionDetailModel, { height: 'auto', width: '90%' });

  }

  getGembaActions(id: number): void {
    const key = {
      gembaWalkId: this.gembaWalkId
    };
    this.rowDataViewActions = [];
    this.gembaService.getGembaActions2(key).subscribe((res) => {
      this.rowDataViewActions = res;
    });
  }

  cellClickedAction(params: any): void {
    this.ButtonTypeGemba = '';
    const col = params.colDef.field;
    this.ButtonTypeGemba = params.event.target.classList[2];
    if (col === 'PictureAfter') {
      this.CloseImage = params.data.PictureAfter
      this.imageZoom();
    }

  }

  getGembafiles(): void {
    const key = {
      GembaId: this.gembaWalkId
    };
    this.slidesImages = []
    this.gembaService.getGembafiles(key).subscribe(
      (listData: any) => {
        if (listData?.length) {
          this.spinner.hide();
          this.dialog.open(this.imageViewModal, {
            height: 'auto',
            width: '90%',
          });
          for (let obj of listData) {
            this.slidesImages.push(obj.FilePath)
          }
        }
        else {
          this.spinner.hide();
          this.toaster.warning('warning', 'There Is No Image Available')
        }
        // this.getPaginator2(this.previewerData, 1);
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  onBtnExportGemba(): void {
    const dataSheet = [];
    const workBook = XLSX.utils.book_new();
    for (let i of this.gembaRowData) {
      const ExportData = {
        ['Observation ']: i.Observation,
        ['Category ']: i.Category,
        ['AreaName ']: i.AreaName,
        ['Status']: i.Status,
        ['Created By ']: i.CreatedBy,
        ['Created On (DD/MM/YYYY HH:mm)']: i.CreatedOn ? moment(i.CreatedOn).format('DD/MM/YYYY HH:mm:ss') : '',
        ['Close Date(DD/MM/YYYY HH:mm)']: i.ClosedDate ? moment(i.ClosedDate).format('DD/MM/YYYY HH:mm:ss') : '',
        ['ClosedBy ']: i.ClosedBy,

      };
      dataSheet.push(ExportData);
    }
    const sheet = XLSX.utils.json_to_sheet(dataSheet);
    XLSX.utils.book_append_sheet(workBook, sheet, 'Gemba Observation');
    XLSX.writeFile(workBook, `Export Gemba.xlsx`);
  }
}
